import VueCookies from 'vue-cookies'


export default {
  get () {
    const url = location.href
    const urlParams = new URLSearchParams(url);
    const token = urlParams.get('token');
    return token? token:VueCookies.get('token')
  },
  set (token) {
    const url = location.href
    if (url.indexOf('localhost') >= 0 || url.indexOf('808') >= 0) {
      VueCookies.set("token", token) // localhost,开发使用
    } else {
      VueCookies.set("token", token, "7d");  // 7天后过期
      VueCookies.set("token", token, "7d", null, ".gpdcloud.net");  // 7天后过期,drm不需要登录
    }

  },
  remove () {
    console.log('remove-token')
    const url = location.href
    if (url.indexOf('localhost') >= 0 || url.indexOf('808') >= 0) {
      VueCookies.remove('token')
    } else {
      VueCookies.remove('token', null, ".gpdcloud.net")
    }

  }
}